import { createContext, useContext } from 'react';
import type { ToggleButtonGroupSize, ToggleButtonGroupTheme } from './types';

interface IToggleButtonGroupContext {
  size: ToggleButtonGroupSize,
  theme: ToggleButtonGroupTheme,
  value: string[],
  onChange: (value: string) => void,
}

const ToggleButtonGroupContext = createContext<IToggleButtonGroupContext | null>(null);

export const useToggleButtonGroupContext = (): IToggleButtonGroupContext => {
  const ctx = useContext(ToggleButtonGroupContext);
  if (!ctx) {
    throw new Error('ToggleButtonGroup.Item must be used within a ToggleButtonGroup');
  }
  return ctx;
};

export default ToggleButtonGroupContext;
